import React from 'react'
import PropTypes from 'prop-types'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

import './DateInput.scss'

class DateInput extends React.Component {
  constructor(props) {
    super(props)
    const { isPop } = this.props
    const numberOfYears = isPop ? 2 : 100
    const yearOptions = Array(numberOfYears)
      .fill()
      .map((_, i) => new Date().getFullYear() - i)
    const monthOptions = Array(12)
      .fill()
      .map((_, i) => i + 1)
    const dayOptions = Array(31)
      .fill()
      .map((_, i) => i + 1)

    const { value: propsValue } = this.props
    const { year: selectedYear, month: selectedMonth, day: selectedDay } = propsValue
    this.state = {
      value: {
        year: parseInt(selectedYear, 10) || '',
        month: parseInt(selectedMonth, 10) || '',
        day: parseInt(selectedDay, 10) || '',
      },
      yearOptions,
      monthOptions,
      dayOptions,
      selectedOption: '',
    }
  }

  componentDidUpdate() {
    const { value: propValue } = this.props
    const { selectedOption } = this.state
    if (typeof propValue === 'string' && propValue.length > 0 && selectedOption !== propValue) {
      this.updateSelectedOption(propValue)
      this._sendValuesToReduxForm()
    }
  }

  updateSelectedOption = selectedOption => this.setState({ selectedOption })

  _handleChange = e => {
    const { value: valueState } = this.state
    const { name, value } = e.target
    const model = valueState
    model[name] = value
    this.setState({ model })
    this._calculateDayOptions()
  }

  _sendValuesToReduxForm = () => {
    const { value } = this.state
    const { onChange } = this.props

    const dateValue = {
      year: value.year,
      month: value.month,
      day: value.day,
    }

    onChange(dateValue)
  }

  _calculateDayOptions() {
    const { value = {} } = this.state
    const { month: selectedMonth, year: selectedYear } = value

    const isLeapYear = year => {
      if (year % 4 === 0) {
        if (year % 100 === 0) {
          if (year % 400 === 0) {
            return true
          }
          return false
        }
        return true
      }
      return false
    }

    const months = {
      1: 31,
      2: selectedYear && isLeapYear(selectedYear) ? 29 : 28,
      3: 31,
      4: 30,
      5: 31,
      6: 30,
      7: 31,
      8: 31,
      9: 30,
      10: 31,
      11: 30,
      12: 31,
    }
    if (selectedMonth) {
      const numberOfDays = months[selectedMonth]
      if (numberOfDays < value.day) {
        value.day = months[value.month]
        this.setState({ value })
      }

      this.setState({
        dayOptions: Array(numberOfDays)
          .fill()
          .map((_, i) => i + 1),
      })
    }
  }

  onBlurHandler = () => {
    this._sendValuesToReduxForm()
  }

  render() {
    const { _handleChange: onChange } = this
    const { dayOptions, monthOptions, yearOptions, value } = this.state
    const {
      label: labelProp,
      name: baseIdent,
      disabled: isDisabled,
      id,
      required,
      'aria-required': ariaRequired,
      'aria-invalid': ariaInvalid,
      'aria-describedby': ariaDescribedBy,
    } = this.props

    const { day: selectedDay, month: selectedMonth, year: selectedYear } = value
    const fieldId = id || baseIdent
    const isRequired = required || ariaRequired

    // Create a groupName for the date inputs so screen readers understand they're related
    const dateGroupName = `${fieldId}-group`

    return (
      <div
        className={`amd-date-input-container ${
          !labelProp ? 'amd-date-input-container-no-label' : ''
        }`}
      >
        <label className="form-label-sm" id={`${dateGroupName}-label`} htmlFor={fieldId}>
          <FormattedMessage id={labelProp} />
          {isRequired && (
            <span className="required-indicator" aria-hidden="true">
              *
            </span>
          )}
          {isRequired && <span className="sr-only">(required)</span>}
        </label>

        <div
          className="form-inline"
          role="group"
          aria-labelledby={`${dateGroupName}-label`}
          id={fieldId}
        >
          <select
            className="form-control amd-date-input"
            type="text"
            id={`${baseIdent}-year`}
            name="year"
            aria-label="Year"
            value={selectedYear}
            onBlur={this.onBlurHandler}
            onChange={onChange}
            disabled={isDisabled}
            required={isRequired}
            aria-required={isRequired}
            aria-invalid={ariaInvalid}
            aria-describedby={ariaDescribedBy}
          >
            <option value="" key="year-default" disabled>
              YYYY
            </option>
            {yearOptions.map(option => (
              <option value={option} key={`year-${option}`}>
                {option}
              </option>
            ))}
          </select>
          <select
            className="form-control amd-date-input"
            type="text"
            id={`${baseIdent}-month`}
            name="month"
            aria-label="Month"
            value={selectedMonth}
            onBlur={this.onBlurHandler}
            onChange={onChange}
            disabled={isDisabled}
            required={isRequired}
            aria-required={isRequired}
            aria-invalid={ariaInvalid}
            aria-describedby={ariaDescribedBy}
          >
            <option value="" key="month-default" disabled>
              MM
            </option>
            {monthOptions.map(option => (
              <option value={option} key={`month-${option}`}>
                {option}
              </option>
            ))}
          </select>
          <select
            className="form-control amd-date-input"
            type="text"
            id={`${baseIdent}-day`}
            name="day"
            aria-label="Day"
            value={selectedDay}
            onBlur={this.onBlurHandler}
            onChange={onChange}
            disabled={isDisabled}
            required={isRequired}
            aria-required={isRequired}
            aria-invalid={ariaInvalid}
            aria-describedby={ariaDescribedBy}
          >
            <option value="" key="day-default" disabled>
              DD
            </option>
            {dayOptions.map(option => (
              <option value={option} key={`day-${option}`}>
                {option}
              </option>
            ))}
          </select>
        </div>
      </div>
    )
  }
}

DateInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      month: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      day: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  isPop: PropTypes.bool,
  id: PropTypes.string,
  required: PropTypes.bool,
  'aria-required': PropTypes.bool,
  'aria-invalid': PropTypes.bool,
  'aria-describedby': PropTypes.string,
}

export default DateInput
